(function () {
    'use strict';

    angular.module('app')
        .factory('LugarOstentacionTesauro', LugarOstentacionTesauro);

    /* @ngInject */
    function LugarOstentacionTesauro($resource) {
        return $resource('api/admin/lugar-ostentacion-tesauro/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar-ostentacion-tesauro/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/lugar-ostentacion-tesauro/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar-ostentacion-tesauro/findAll'
            }
        });
    }
})();
